<script setup lang="ts">
import { EVENT_TIME_FILTERS, type EventTimeFilter } from '../lib/const';

defineProps<{
  active: EventTimeFilter;
}>();

const emit = defineEmits<{
  change: [value: EventTimeFilter];
}>();
</script>

<template>
  <div :class="$style.tabs">
    <Button
      theme="white"
      size="small"
      :class="[
        $style.tab,
        { [$style.tab_active!]: active === EVENT_TIME_FILTERS.upcoming },
      ]"
      @click="emit('change', EVENT_TIME_FILTERS.upcoming)"
    >
      Предстоящие
    </Button>
    <Button
      theme="white"
      size="small"
      :class="[
        $style.tab,
        { [$style.tab_activePast!]: active === EVENT_TIME_FILTERS.past },
      ]"
      @click="emit('change', EVENT_TIME_FILTERS.past)"
    >
      Прошедшие
    </Button>
  </div>
</template>

<style module lang="scss">
.tabs {
  display: flex;
  gap: 4px;
  align-items: center;
}

.tab {
  height: 40px;
  min-height: 40px;

  &_active {
    background-color: var(--color-event-accent);
    color: var(--color-white);
    border: 1px solid var(--color-gray-line);

    &:hover {
      background-color: var(--color-event-accent);
      color: var(--color-white);
    }
  }

  &_activePast {
    background-color: var(--color-gray-text);
    color: var(--color-white);
    border: 1px solid var(--color-gray-text);

    &:hover {
      background-color: var(--color-gray-text);
      color: var(--color-white);
    }
  }
}
</style>
